import React, { useEffect, useState } from 'react'
import Layout from '../../../brands/components/Layout'
import { Formik } from 'formik' //FormikHelpers
import { InputField } from '../../../../components'
import './index.css'
import { useNavigate, useLocation } from 'react-router-dom'
import { formSchema } from '../../schema'
import { createForm, getForm, updateForm } from '../../api'
import { useAppDispatch } from '../../../../redux/hook'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'

interface FormValues {
    title: string
    file: File | null
    fileName: string
}
const initialValues: FormValues = {
    title: '',
    file: null,
    fileName: '',
}

const UploadForm: React.FC = () => {
    const [formValues, setFormValues] = useState(initialValues)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const fileInputRef = React.useRef<HTMLInputElement>(null)
    const handleSubmit = async (
        values: FormValues
        // actions: FormikHelpers<FormValues>
    ) => {
        dispatch(SHOW_LOADER())
        // actions.setSubmitting(true)
        const formData = new FormData()
        formData.append('Title', values.title)
        formData.append('LocationId', '')
        formData.append('File', values.file as File)
        if (location.pathname.split('/')[2] === 'edit') {
            formData.append('id', location.pathname.split('/')[3])
            await updateForm(formData)
        } else {
            await createForm(formData)
        }
        // actions.setSubmitting(false)
        dispatch(
            SHOW_NOTIFICATION({
                type: 'success',
                message:
                    location.pathname.split('/')[2] === 'edit'
                        ? 'Form updated successfully'
                        : 'Form created successfully',
            })
        )
        navigate('/forms')
        dispatch(HIDE_LOADER())
    }

    useEffect(() => {
        const loadFormData = async (id: string) => {
            const res = await getForm(id)
            setFormValues({
                title: res.data.title,
                file: res.data.fileName,
                fileName:
                    res.data.fileName + '.' + res.data.formPath.split('.')[1],
            })
            dispatch(HIDE_LOADER())
        }

        const pathArray = location.pathname.split('/')
        if (pathArray[2] === 'edit') {
            dispatch(SHOW_LOADER())
            loadFormData(pathArray[3])
        }
    }, [location.pathname])

    const handleFileChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        setFieldValue: (field: string, value: any) => void
    ) => {
        const file = e.target.files?.[0]
        setFieldValue('file', file)
        setFieldValue('fileName', file?.name)
        setTimeout(() => {
            if (fileInputRef.current) {
                fileInputRef.current.blur() // Explicitly call blur() on the input element
            }
        }, 0)
    }
    return (
        <div>
            <Layout>
                <div className="">
                    <div className="mb-3">
                        <h4>Upload Form</h4>
                    </div>
                    <div className="upload-form">
                        <Formik
                            initialValues={formValues}
                            validationSchema={formSchema}
                            onSubmit={handleSubmit}
                            enableReinitialize
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                setFieldValue,
                                isSubmitting,
                            }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className="row mrg-top">
                                        <div className="col-sm-6">
                                            <InputField
                                                type="text"
                                                lable="Title"
                                                name="title"
                                                value={values.title}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.title}
                                                touched={touched.title}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mrg-top">
                                        <div className="col-sm-6">
                                            <label>Select File</label>
                                            <div className="file-box">
                                                <span className="">
                                                    {values.fileName}
                                                    {/* Display file name */}
                                                </span>
                                                <input
                                                    type="file"
                                                    className="input-file"
                                                    id="file"
                                                    name="file"
                                                    ref={fileInputRef}
                                                    onChange={(e) => {
                                                        handleFileChange(
                                                            e,
                                                            setFieldValue
                                                        )
                                                    }}
                                                    onBlur={handleBlur}
                                                />
                                                <label
                                                    htmlFor="file"
                                                    className="btn btn-upload"
                                                >
                                                    BROWSE
                                                </label>
                                            </div>
                                            {values.file &&
                                            values.fileName &&
                                            touched.file &&
                                            errors.file ? (
                                                <div className="error">
                                                    {errors.file}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>

                                    <div className="row mt-4 mb-4">
                                        <div className="col-sm-6 button-block">
                                            <button
                                                disabled={isSubmitting}
                                                className="button button-primary me-5"
                                                type="submit"
                                            >
                                                UPLOAD
                                            </button>

                                            <button
                                                className="button button-outline"
                                                onClick={() =>
                                                    navigate('/forms')
                                                }
                                            >
                                                CANCEL
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                </div>
            </Layout>
        </div>
    )
}

export default UploadForm
